/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_EyebrowInputs */

const en_fc_home_hero_eyebrow = /** @type {(inputs: Fc_Home_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free, open-source Premiere Pro alternative`)
};

/**
* | output |
* | --- |
* | "A free, open-source Premiere Pro alternative" |
*
* @param {Fc_Home_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_eyebrow = /** @type {((inputs?: Fc_Home_Hero_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_eyebrow(inputs)
});
export { fc_home_hero_eyebrow as "fc.home.hero.eyebrow" }